var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseMedium = function SvgCloseMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#close-medium_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.806 4.194a.875.875 0 0 1 0 1.237l-5.069 5.07 5.07 5.068a.875.875 0 0 1-1.238 1.237L10.5 11.738l-5.069 5.068a.875.875 0 1 1-1.237-1.237L9.263 10.5l-5.07-5.069a.875.875 0 1 1 1.238-1.237L10.5 9.263l5.069-5.07a.875.875 0 0 1 1.237 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "close-medium_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21v21H0z"
  })))));
};
export default SvgCloseMedium;